import { createAsyncThunk } from '@reduxjs/toolkit';
import type { CreateQuestionBody, UpdateQuestionBody } from 'src/openapi';
import apiClient from 'src/helpers/apiClient';

export const getCreatedQuestions = createAsyncThunk(
  'get/created-questions',
  async (
    {
      pageNo,
      pageSize,
      questionStatus,
    }: {
      pageNo?: number;
      pageSize?: number;
      questionStatus?: string;
      search?: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await (
        await apiClient.getUserApi()
      ).userApiGetUserCreatedQuestions({
        page: pageNo,
        pageSize,
        questionStatus,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getQuestionCreationMilestone = createAsyncThunk(
  'get/question-milestone',
  async (_, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getQuestionApi()
      ).questionApiQuestionCreateMilestone();
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const createQuestion = createAsyncThunk(
  'post/createQuestion',
  async (data: CreateQuestionBody, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getQuestionApi()
      ).questionApiCreateQuestion({ createQuestionBody: data });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const updateQuestion = createAsyncThunk(
  'put/update-question',
  async (
    {
      questionId,
      payload,
    }: { questionId: string; payload: UpdateQuestionBody },
    { rejectWithValue },
  ) => {
    try {
      const response = await (
        await apiClient.getQuestionApi()
      ).questionApiUpdateQuestion({ questionId, updateQuestionBody: payload });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const deleteQuestion = createAsyncThunk(
  'delete/question',
  async ({ questionId }: { questionId: string }, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getQuestionApi()
      ).questionApiDeleteQuestion({ questionId });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getQuestionById = createAsyncThunk(
  'get/question-by-Id',
  async (questionId: string, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getQuestionApi()
      ).questionApiGetQuestionById({ questionId });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getQuestionsStatistics = createAsyncThunk(
  'get/question-statistics',
  async ({ questionId }: { questionId: string }, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getQuestionApi()
      ).questionApiGetQuestionStatistics({ questionId });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getQuestionsCreationSkills = createAsyncThunk(
  'get/question-creation-skills',
  async (
    {
      searchQuery,
      pageNo,
      pageSize,
    }: { searchQuery: string; pageNo?: number; pageSize?: number },
    { rejectWithValue },
  ) => {
    try {
      const response = await (
        await apiClient.getSkillsApi()
      ).skillApiGetQuestionCreationSkillList({
        page: pageNo,
        pageSize,
        searchQuery,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getQuestionReviewData = createAsyncThunk(
  'get/question-review-data',
  async (questionId: string, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getQuestionApi()
      ).questionApiGetQuestionReviewData({ questionId });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data);
    }
  },
);
